import { berryPastels, berryPastelsDark } from 'themes/palette';

export type ProjectType = {
  code: string;
  title: string;
  show: boolean;
  colour: string;
  backgroundColour: string;
};

export type ModelType = {
  value: string;
  label: string;
  isDefault: boolean;
};

type LookupRow = Record<string, unknown>;

export function mapProjectTypes(rows: LookupRow[]): ProjectType[] {
  const fallbackColours = Object.values(berryPastelsDark);
  const fallbackBackgroundColours = Object.values(berryPastels);
                    console.log(rows);
                                
  const aaa = rows.map((row, i) => ({
    code: String(row.code ?? row.Code ?? ''),
    title: String(row.title ?? row.Title ?? ''),
    show:
      String(row.show ?? row.Show ?? '').trim() === '1' ||
      String(row.show ?? row.Show ?? '').toLowerCase() === 'true',
    colour: String(
      row.colour ??
        row.Colour ??
        fallbackColours[i % fallbackColours.length]
    ),
        backgroundColour: String(
      row.backgroundColour ??
        row.BackgroundColour ??
        fallbackBackgroundColours[i % fallbackBackgroundColours.length]
    )
  }));
  console.log(aaa);
  return aaa;
}

export function mapModelTypes(rows: LookupRow[]): ModelType[] {
  return rows.map((row) => ({
    value: String(row.value ?? ''),
    label: String(row.label ?? ''),
    isDefault:
      String(row.default ?? row.isDefault ?? '').trim() === '1' ||
      String(row.default ?? row.isDefault ?? '').toLowerCase() === 'true'
  }));
}